export default __webpack_public_path__ + "static/media/streaks 300.2c77b73c.svg";